import React from 'react'

import { SupportProvider, useConfig } from '../../context/config'
import { SupportStackScreenProps } from '../../navigation/MainTabs/Support'

import { CustomSupportView } from './Custom'
import { ZendeskSupportView } from './Zendesk'

type SupportProps = SupportStackScreenProps<'Support'>

export const Support: React.FC<SupportProps> = () => {
  const { config } = useConfig()

  switch (config.partnerConfig?.supportProvider.type) {
    case SupportProvider.Custom:
      return <CustomSupportView />
    case SupportProvider.Zendesk:
      return <ZendeskSupportView />
    default:
      return <CustomSupportView />
  }
}
